<homey-text-page>
  <div>
    <homey-page-title-layout>Your data</homey-page-title-layout>
    <p>Your privacy and security are our top priorities. We understand that applying for affordable housing involves
      sharing sensitive information, and we are committed to protecting it at every step. Our platform is designed to
      keep your data safe, limit what we collect, and ensure it is only used for its intended purpose—helping you secure
      housing.</p>
  </div>
  <div>
    <homey-page-subtitle title="We only ask for the essentials"/>
    <p>We collect only the information strictly necessary to complete and submit your housing applications. This means
      we never ask for your Social Security Number (SSN) or official documents like pay slips or bank statements. Our
      goal is to streamline the process while minimizing the amount of personal data you need to provide.</p>
  </div>
  <div>
    <homey-page-subtitle title="We only share with HPD"/>
    <p>Your data is used solely for submitting applications to the New York City Department of Housing Preservation and Development (HPD) or relevant housing
      agencies. We never sell, share, or distribute your personal information to third parties for marketing or any
      other purposes. Your trust is important to us, and we ensure that your information is handled with the highest
      level of confidentiality.</p>
  </div>
  <div>
    <homey-page-subtitle title="We encrypt and protect your data"/>
    <homey-paragraphs>
      <p>We follow Privacy by Design, meaning security is built into every step of our process.</p>
      <p>All data transfers are secured with HTTPS/SSL, and we implement encryption at rest on secure servers to keep
        stored information safe. Your data is securely stored in DynamoDB, and authentication is managed through AWS
        Cognito, which includes industry certifications and handles security-critical tasks for us. We also keep our
        systems up to date and actively monitor security vulnerabilities (CVEs) to stay ahead of potential threats.</p>
    </homey-paragraphs>
  </div>
  <div>
    <homey-page-subtitle title="Want us to delete all your data?"/>
    <p>You can delete your data anytime from the profile page in the app. Need help? Just email us at <a
      href="mailto:admin@myhomey.io">admin&#64;myhomey.io</a>, and we’ll handle it for you.</p>
  </div>
</homey-text-page>
<homey-lotteries-and-footer/>
